import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PostItemProps } from "apis/post";
import { PaginationProps } from "utils/types/API";

interface PostPageData {
    page: number;
    data: PostItemProps[];
}
export interface PostState {
    loading: boolean;
    list: {
        data: PostItemProps[];
        pagination?: PaginationProps;
    };
    pages: PostPageData[];
    item: {
        data?: PostItemProps;
        relate: PostItemProps[];
    };
}

const initialState: PostState = {
    loading: false,
    list: {
        data: []
    },
    pages: [],
    item: {
        relate: []
    }
};

interface IndexProps {
    data: PostItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: PostItemProps;
}
export const postSlice = createSlice({
    name: "post",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;

            if (state.list.pagination?.page) {
                state.pages = [
                    ...state.pages.filter(p => p.page !== state.list.pagination?.page),
                    { page: state.list.pagination?.page, data: action.payload.data },
                ]
            }

        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },

        relate: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.item.relate = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, find, create, update, relate } = postSlice.actions;
export default postSlice.reducer;
